import classNames from 'classnames';
import {
  normalizePlayerTheme,
  usesLogoTheme,
  type PlayerThemeId,
} from 'lib/playerTheme';
import styles from './BrandLogo.module.css';
import { Wordmark } from './Wordmark';

type BrandLogoProps = {
  theme?: string | null;
  className?: string;
  onClick?: () => void;
  variant?: 'header' | 'overlay' | 'login';
};

export function BrandLogo({
  theme,
  className,
  onClick,
  variant = 'header',
}: BrandLogoProps) {
  const resolved = normalizePlayerTheme(theme);

  if (usesLogoTheme(resolved)) {
    return (
      <img
        src="/photos/logo.png"
        alt="Tottalo"
        className={classNames(styles.logoImage, styles[variant], className)}
        onClick={onClick}
      />
    );
  }

  return (
    <span
      className={classNames(styles.markWrap, styles[variant], className)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <Wordmark className={styles.mark} />
    </span>
  );
}

export function brandThemeFromUser(
  user?: { player_theme?: string | null } | null
): PlayerThemeId {
  return normalizePlayerTheme(user?.player_theme);
}
